import { createMailersTemplate } from 'bundles/connect/helpers/prospect_api';
import React, { useState } from 'react';
import { Button, Form, FormGroup, Modal, Spinner } from 'react-bootstrap-5';

type Props = {
  callListId: number,
  show: boolean,
  onClose: () => void
}

export default function CreateTemplateModal({ callListId, show, onClose }: Props) {
  const [title, setTitle] = useState('');
  const [saving, setSaving] = useState(false);

  const handleCreate = () => {
    setSaving(true);
    createMailersTemplate(callListId, title)
      .then(({ path }) => {
        setTimeout(() => window.location.href = path, 1000);
      })
      .catch(() => setSaving(false));
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header className="flex-row">Create New Template</Modal.Header>
      <Modal.Body>
        <FormGroup>
          <Form.Label>Template Name</Form.Label>
          <Form.Control value={title} onChange={e => setTitle(e.target.value)} />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={!title} variant="secondary" onClick={handleCreate}>
          {saving && (
            <>
              <Spinner animation="border" size="sm" />
              <span>Saving ...</span>
            </>
          )}
          {!saving && 'Create and Edit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
